import './fiocTgssConsent.scss';

import React, { useEffect } from 'react';
import { useModal } from 'hooks/useModal';
import CheckBox from 'components/checkBox/checkBox';
import { formatText } from 'core/i18n';
import { PdfModal } from 'componentsV2/PdfModal/PdfModalContainer';
import { usePdfModal } from 'hooks/usePdfModal';
import { recordEventCustomOnly } from 'utilities/uTagging';

const PDF_PATH = 'https://www.openbank.es/assets/static/pdf/Productos/Otros/Consulta_Tesoreria.pdf';
const PDF_FILE_NAME = 'fioc-tgssDocumentName';

export const FiocTgssConsent = ({ userProfile, userProfileForm, formActions }) => {
    const { isOpen, toggleModal } = useModal();
    const {
        isDocumentAccepted,
        isDocumentRead,
        handleDocumentAccepted: onDocumentAccepted,
        handleDocumentRead,
    } = usePdfModal();

    useEffect(() => {
        return () => {
            formActions.change('userProfile.fiocTgssConsent', false);
        };
    }, []);

    const handleDocumentAccepted = () => {
        onDocumentAccepted();
        formActions.change('userProfile.fiocTgssConsent', true);
        toggleModal();
    };

    const handleClickDocumentLabel = () => {
        recordEventCustomOnly({
            categoriaEvento: 'interaccion en tu actividad',
            accionEvento: 'clickLink',
            etiquetaEvento: 'documento consulta TGSS',
        });
        toggleModal();
    };

    const createLabelText = () => {
        return (
            <span className={'fiocTgssConsent-label'}>
                {formatText('fioc-tgssConsentIAgree')}
                <button type="button" onClick={handleClickDocumentLabel}>
                    {formatText('fioc-tgssConsentDocument')}
                </button>
                {formatText('fioc-tgssConsentAcceptConsult')}
            </span>
        );
    };

    const handleOnChange = value => {
        recordEventCustomOnly({
            categoriaEvento: 'interaccion en tu actividad',
            accionEvento: value ? 'check' : 'uncheck',
            etiquetaEvento: 'acepto consulta TGSS',
        });
        value && !isDocumentAccepted && toggleModal();
        !isDocumentAccepted && formActions.change('userProfile.fiocTgssConsent', false);
    };

    const buildPdfFileName = () => {
        return `${formatText(PDF_FILE_NAME)}.pdf`;
    };

    return (
        <>
            <label>{formatText('fiocTgssConsent-giveUsPermission')}</label>
            <label className="sub-label">{formatText('fiocTgssConsent-itWillHelpUs')}</label>
            <CheckBox
                profileModel="userProfile.fiocTgssConsent"
                checkBoxList={[
                    {
                        label: createLabelText(),
                        model: 'userProfile.fiocTgssConsent',
                        onChange: handleOnChange,
                    },
                ]}
                userProfile={userProfile}
                userProfileForm={userProfileForm}
                formActions={formActions}
            />

            <PdfModal
                path={PDF_PATH}
                onDownloadFileName={buildPdfFileName()}
                showModal={isOpen}
                toggleModal={toggleModal}
                isDocumentAccepted={isDocumentAccepted}
                onDocumentAccepted={handleDocumentAccepted}
                isDocumentRead={isDocumentRead}
                onDocumentRead={handleDocumentRead}
            />
        </>
    );
};
